import styled from 'styled-components';
import { colors, media } from '@prisjakt/ui-base';

export const Wrapper = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  cursor: pointer;
  transform-origin: center center;
  backface-visibility: hidden;
  border-radius: 50%;
  overflow: hidden;
  background-color: ${colors.lightBlue1};
  box-shadow: 0px 0px 25px 0px rgba(184, 184, 184, 0.5);
  outline: none;
  z-index: 1;
  ${media.mediumDown`
    display: none;
  `};
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  opacity: 1;
  transform: rotate(0deg) scale(1);
  transition: transform 0.4s ease 0.2s;
  cursor: pointer;

  > svg {
    width: 28px;
    height: 32px;
  }
`;
